<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Terms</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" :class="{ 'is-danger': errors.payment_terms }">
                        <select v-model="payment_terms">
                            <option value="" selected>Select Payment Terms</option>
                            <option value="100">100%</option>
                            <option value="50">50%/50%</option>
                            <option value="30">30%/70%</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                       <i class="fas fa-book"></i>
                    </span>
                    <p v-if="errors.payment_terms" class="help is-danger">{{ errors.payment_terms[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            payment_terms: {
                get() {
                    return this.$store.getters.getNewPricePlan.payment_terms
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'payment_terms', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/PaymentTermsInput.vue